export type IsSubstringOptions = {
  ignoreDiacritics: boolean
  ignoreCase: boolean
}

export const removeDiacritics = (str: string): string =>
  str.normalize("NFD").replace(/[\u0300-\u036f]/g, "")

export const contains = (
  str: string,
  substring: string,
  { ignoreDiacritics, ignoreCase }: IsSubstringOptions = {
    ignoreDiacritics: false,
    ignoreCase: false,
  }
): boolean => {
  const [normalizedString, normalizedSubstring] = [str, substring]
    .map((value) => (ignoreDiacritics ? removeDiacritics(value) : value))
    .map((value) => (ignoreCase ? value.toLowerCase() : value))
  return normalizedString.includes(normalizedSubstring)
}
